import { Autocomplete, TextField } from '@mui/material';

const TicketsFilter = ({ tickets, handleFilterByUsername, selectedUser }) => {
    return (
        <div className="w-100">
            <Autocomplete
                id="steps-responsable"
                className="tickets__select"
                options={[
                    'Todos',
                    ...new Set(
                        tickets.map(
                            (pendiente) => pendiente.crafted_by.username
                        )
                    ),
                ]}
                getOptionLabel={(option) => option}
                onChange={(event, newValue) => {
                    handleFilterByUsername(newValue);
                }}
                value={selectedUser}
                autoHighlight
                renderInput={(params) => (
                    <TextField {...params} label="Responsable" />
                )}
            />
        </div>
    );
};

export default TicketsFilter;
